/** @format */

import React from "react";

//pages

//market and profile pages
import ErrorRoute from "../../router/error-route";
import Jobs from "../../views/dashboard/app/job/jobs";
import UserProfile from "../../views/dashboard/profiles/user-profile";
import UsrIndex from "../../views/dashboard/usr_index";

export const ProtectedRouter = [
  {
    key: "index",
    path: "/u",
    element: <UsrIndex />,
  },
  {
    key: "jobs",
    path: "/u/jobs",
    element: <Jobs />,
  },
  {
    key: "error",
    path: "*",
    element: <ErrorRoute />,
  },
  {
    key: "user-profile",
    path: "/u/user_profile",
    element: <UserProfile />,
  },
];
